import React from "react";
import { Avatar, Tooltip } from "@chakra-ui/react";

type GenderImageProps = {
  voice?: {
    avatar_url?: string | null;
    voice_name?: string | null;
  } | null;
  /**
   * Chakra Avatar size token (e.g. "xs" | "sm" | "md" | "lg" | "xl" | "2xl")
   * Defaults to "sm"
   */
  size?: string;
  /**
   * Optional override for exact px sizing (e.g. "52px"). If provided, takes priority.
   */
  boxSize?: string;

  /** Margin right */
  mr?: number;
};

const GenderImage: React.FC<GenderImageProps> = ({
  voice,
  size = "undefined",
  boxSize = "20px",
  mr = 2,
}) => {
  const voiceName = voice?.voice_name?.trim() || "Unknown Voice";

  const avatar = (
    <Avatar
      src={voice?.avatar_url || undefined}
      name={voice?.voice_name || undefined}
      size={size}
      boxSize={boxSize}
      mr={mr}
      bg="gray.300"
      color="gray.700"
      flexShrink={0}
    />
  );

  return (
    <Tooltip label={voiceName} hasArrow placement="top" openDelay={250}>
      {/* Tooltip needs a single element child */}
      <span style={{ display: "inline-flex" }}>{avatar}</span>
    </Tooltip>
  );
};

export default GenderImage;
